// <s-infinite-scroll>: loads the next collection page when the shopper nears the end of the grid
// and appends its items to the grid named in data-grid (default #product-grid; search uses #search-results-grid). The pagination links inside stay as the no-JS fallback.
// Filter/sort changes re-render the 'collection-grid' partial, which reconnects a fresh element.
class InfiniteScroll extends HTMLElement {
  connectedCallback() {
    this.nextUrl = this.dataset.nextUrl;
    this.grid = document.getElementById(this.dataset.grid || 'product-grid');
    this.fallback = this.querySelector('[data-pagination-fallback]');
    this.status = this.querySelector('[data-infinite-status]');
    this.retry = this.querySelector('[data-infinite-retry]');
    if (!this.nextUrl || !this.grid) {
      this.fallback?.setAttribute('hidden', '');
      return;
    }
    this.fallback?.setAttribute('hidden', '');
    this.retry?.addEventListener('click', () => this.loadNext());
    this.io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) this.loadNext();
    }, { rootMargin: '800px 0px' });
    this.io.observe(this);
  }

  disconnectedCallback() {
    this.io?.disconnect();
    this.controller?.abort();
  }

  async loadNext() {
    if (this.loading || !this.nextUrl) return;
    this.loading = true;
    this.setAttribute('data-loading', '');
    this.retry?.setAttribute('hidden', '');
    this.controller = new AbortController();
    try {
      const res = await fetch(this.nextUrl, { signal: this.controller.signal });
      if (!res.ok) throw new Error(String(res.status));
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const items = doc.querySelectorAll('#' + CSS.escape(this.grid.id) + ' > li');
      const fragment = document.createDocumentFragment();
      items.forEach((li) => fragment.append(document.importNode(li, true)));
      this.grid.append(fragment);
      const next = doc.querySelector('s-infinite-scroll');
      this.nextUrl = next?.dataset.nextUrl || '';
      if (this.status) this.status.textContent = this.dataset.loadedMessage?.replace('__count__', String(this.grid.children.length)) ?? '';
      if (!this.nextUrl) {
        this.io?.disconnect();
        this.setAttribute('data-done', '');
      }
    } catch (error) {
      if (error.name !== 'AbortError') this.retry?.removeAttribute('hidden');
    } finally {
      this.loading = false;
      this.removeAttribute('data-loading');
    }
  }
}

if (!customElements.get('s-infinite-scroll')) customElements.define('s-infinite-scroll', InfiniteScroll);
